import * as React from 'react';
import { EnhancedProps } from './props';
import { Transition } from 'semantic-ui-react';

export default (props: EnhancedProps) => (
  <span onClick={() => { props.onClickHandler(); props.handleOnClick(); }}>
  {!props.didRender &&
    props.children
  }
    <Transition
      animation={props.animation}
      duration={props.duration}
      visible={props.visible}
      onComplete={props.handleOnComplete}
    >
      {props.children}
    </Transition>
  </span>
);


// WEBPACK FOOTER //
// ./src/components/retransition/component.tsx